<template> 
<div>
  <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-form-select class="parrafos" size="sm parrafos" v-model="data.item.idespecialidad">
        <b-form-select-option v-for="elem in data.item.especialidadesPtiAltoRiesgo" 
        :key="elem.idEspecialidad" :value="elem.idEspecialidad">{{ elem.nombreEspecialidad }}
        </b-form-select-option>
    </b-form-select>
 
    <br/><br/>
    <b-form-select class="parrafos" size="sm parrafos" v-model="data.item.idEmpleadoCoordinador"  v-if="coordinadores.length > 0">
        <b-form-select-option        
         v-for="elem in coordinadores"          
        :key="elem.idEmpleado" :value="elem.idEmpleado"
        >{{ elem.nombre }}
        </b-form-select-option> 
    </b-form-select> 
</div> 
</template>

<script>
export default {
    name: "BandejaEspecialidadComponente",
    props: {
        data: Object,
        resource: Object
    },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
    methods: { 
    },
    computed : {
        coordinadores(){
            if(this.data.item.coordinadorEspecialidad != undefined && this.data.item.coordinadorEspecialidad != null  ){
                return this.data.item.coordinadorEspecialidad.filter( elemento => {
                    return this.data.item.idespecialidad === elemento.idEspecialidad
                } );
            }
            return [];
        }
    }
}
</script>
